export class TrayInfo {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get tray() {
        return this.parent;
    }
    get app() {
        return this.tray.app;
    }
}
